import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} em {{waitingTime}} min',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Entrega',
    [ORDER_METHODS.PICKUP]: 'Para levar',
    [ORDER_METHODS.ROOM_SERVICE]: 'Serviço de quarto',
  },
};
